import { CONTRACT_ADDRESSES } from '../constants/contracts';

/**
 * Contract configuration for different networks
 * Maps network IDs to contract addresses and configurations
 */
const contracts = {
  // Optimism Sepolia Testnet
  optimismSepolia: {
    celToken: CONTRACT_ADDRESSES.OPTIMISM_SEPOLIA.CEL_TOKEN,
    innovationUnits: CONTRACT_ADDRESSES.OPTIMISM_SEPOLIA.INNOVATION_UNITS,
    projectStaking: CONTRACT_ADDRESSES.OPTIMISM_SEPOLIA.PROJECT_STAKING,
    emissionController: CONTRACT_ADDRESSES.OPTIMISM_SEPOLIA.EMISSION_CONTROLLER,
    protocolTreasury: CONTRACT_ADDRESSES.OPTIMISM_SEPOLIA.PROTOCOL_TREASURY
  },
  
  // Optimism Mainnet (using same addresses for now, should be updated with mainnet addresses)
  optimism: {
    celToken: CONTRACT_ADDRESSES.OPTIMISM_SEPOLIA.CEL_TOKEN,
    innovationUnits: CONTRACT_ADDRESSES.OPTIMISM_SEPOLIA.INNOVATION_UNITS,
    projectStaking: CONTRACT_ADDRESSES.OPTIMISM_SEPOLIA.PROJECT_STAKING,
    emissionController: CONTRACT_ADDRESSES.OPTIMISM_SEPOLIA.EMISSION_CONTROLLER,
    protocolTreasury: CONTRACT_ADDRESSES.OPTIMISM_SEPOLIA.PROTOCOL_TREASURY
  },
  
  // Local development network
  localhost: {
    celToken: CONTRACT_ADDRESSES.LOCALHOST.CEL_TOKEN,
    innovationUnits: CONTRACT_ADDRESSES.LOCALHOST.INNOVATION_UNITS,
    projectStaking: CONTRACT_ADDRESSES.LOCALHOST.PROJECT_STAKING,
    emissionController: CONTRACT_ADDRESSES.LOCALHOST.EMISSION_CONTROLLER,
    protocolTreasury: CONTRACT_ADDRESSES.LOCALHOST.PROTOCOL_TREASURY
  }
};

export default contracts; 